<template>
  <div class="content">
    <div class="page-inner">
      <div class="text-35 pb-2 bold-500 mb-3">{{ $t('on_demand_services') }}</div>
      <div class="mb-5 text-16 bold-400" v-html="$t('service_on_demand_description')"></div>

      <router-link to="/upgrade" class="card card-dark bg-secondary-gradient upgrade-banner">
        <div class="card-body bubble-shadow">
          <h2 class="mb-0">{{ $t('upgrade_to_pro') }}</h2>
          <div class="row">
            <div class="col-8 pr-0">
              <h3 class="fw-bold mb-1">{{ $t('and_unlock_features') }}</h3>
              <div class="text-small text-uppercase fw-bold op-8">{{ $t('features_details') }}</div>
            </div>
            <div class="col-4 pl-0 text-right">
              <h3 class="fw-bold mb-1">$4.16</h3>
              <div class="text-small text-uppercase fw-bold op-8">{{ $t('monthly') }}</div>
            </div>
          </div>
        </div>
      </router-link>

      <p class="p-2">
        {{ $t('buy_what_you_need') }}
      </p>

      <div class="row services mt-4">
        <div class="element col-sm-6 col-lg-3" v-for="(service, index) in servicesOnDemandOptions" v-bind:key="`service_${index}`">
          <a href="javascript:void(0)" @click="createPayment(service)" class="card p-3" :class=" ($route.query.key && $route.query.key === service.key) ? 'selected' : ''">
            <div class="d-flex align-items-center">
              <span :class="`stamp stamp-md bg-${service.color} mr-3`">
                <i :class="service.icon"></i>
              </span>
              <div>
                <h5 class="mb-1">
                  {{ service.text }}
                </h5>
                <small class="text-muted">${{ service.price }} USD</small>
              </div>
            </div>
          </a>
        </div>
      </div>

      <div class="row mt-5 mb-3">
        <div class="col-lg-12">
          <div class="text-20">{{ $t('all_services') }}</div>
          <div class="table-responsive">
            <table class="table mt-2">
              <thead>
                <tr>
                  <th>{{ $t('service') }}</th>
                  <th>{{ $t('request_date') }}</th>
                  <th>{{ $t('payment_date') }}</th>
                  <th>{{ $t('state') }}</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(service, index) in services" v-bind:key="`service_${index}`">
                  <td>{{ service.service_type.name }}</td>
                  <td>{{ moment(service.createdAt).format('LL') }}</td>
                  <td><span v-if="service.paidAt">{{ moment(service.paidAt).format('LL') }}</span></td>
                  <td>{{ getState(service.status) }}</td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import _ from 'underscore'
import moment from 'moment'
import Select2 from './utils/Select2'
import ServicesOnDemand from '../services/services-on-demand'
export default {
  name: 'ServicesOnDemand',
  data: function () {
    return {
      saving: false,
      user: {},
      services: [],
      servicesOnDemandId: '',
      servicesOnDemandOptions: [],
      currency: new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD' }),
      stripe: null,
      moment: moment
    }
  },
  methods: {
    getState: function (status) {
      let statusOptions = {
        state_0: this.$t('pending_payment'),
        state_1: this.$t('available'),
        state_2: this.$t('applied'),
        state_3: this.$t('expired')
      }
      return statusOptions['state_' + status]
    },
    createPayment: function (service) {
      this.saving = true
      ServicesOnDemand.createRequest(service._id).then(response => {
        let urlToSuccess = 'https://' + location.hostname + `${window.apiURL}api/user/services-on-demand/confirm/` + response.data.info
        // eslint-disable-next-line
        if (!!window.location.href.match(/localhost|cms-development|staging/)) {
          console.log(urlToSuccess)
        } else {
          let priceId = this.user.role === 'admin' ? service.test_price_id : service.price_id
          this.stripe.redirectToCheckout({
            lineItems: [{ price: priceId, quantity: 1 }],
            mode: 'payment',
            customerEmail: this.user.email,
            successUrl: urlToSuccess,
            cancelUrl: 'https://' + location.hostname + '/extra-features/?cancelled=1'
          }).then(function (result) {
            console.log(result)
            if (result.error) {
              alert(result.error.message)
            }
          })
        }
      })
    }
  },
  created: function () {
    this.user = this.$user
    this.stripe = window.Stripe('pk_live_Fy0LR9SOyRoSrq4Byoj3mQtS00GjNUCMRm')
    ServicesOnDemand.getAllServicesType().then(response => {
      this.servicesOnDemandOptions = _.map(response.data, elem => {
        return {
          _id: elem._id,
          text: elem.name,
          price: elem.price,
          key: elem.key,
          price_id: elem.price_id,
          test_price_id: elem.test_price_id,
          color: elem.color,
          icon: elem.icon
        }
      })

      if (this.$route.query.key) {
        _.each(this.servicesOnDemandOptions, (elem, idx) => {
          if (this.$route.query.key === elem.key) {
            setTimeout(() => {
              this.servicesOnDemandId = String(elem.id)
            }, 10)
          }
        })
      }
    })
    ServicesOnDemand.getAllServices().then(response => {
      if (response.data.length) {
        this.services = response.data
      }
    })
  },
  components: {
    Select2
  }
}
</script>
<style scoped lang="scss">
.element {
  a {
    min-height: 100px;
    &.selected {
      box-shadow: 0px 0px 11px 0px #e22369;
    }
  }
}

.upgrade-banner:hover {
  text-decoration: none !important;
  color: white !important;
}
</style>



// WEBPACK FOOTER //
// src/components/ServicesOnDemand.vue